import { integer, maxValue, minValue, nullable, number, object, optional, pipe, type InferOutput } from 'valibot'

export const CurrentEDCSSchema = object({
  edc: pipe(number(), integer(), minValue(0), maxValue(7)),
  s: number(),
})

export type CurrentEDCS = InferOutput<typeof CurrentEDCSSchema>

export const NullableCurrentEDCSSchema = nullable(CurrentEDCSSchema)

export type NullableCurrentEDCS = InferOutput<typeof NullableCurrentEDCSSchema>

export const OptionalNullableCurrentEDCSSchema = optional(NullableCurrentEDCSSchema)

export type OptionalNullableCurrentEDCS = InferOutput<typeof OptionalNullableCurrentEDCSSchema>
